<template>
<div class="swipe-activity-wrapper" :class="ifImage()">
  <div class="flex items-center content-center justify-center flex-row relative">
    <div class="swipeleft"><span class="w-20 lg:w-48 text-right">Swipe key or <br>Left Arrow Key <br> <span class="text-lg font-bold">Less Me</span></span>
    </div>

    <vue-swing
      @throwoutleft="onLeftThrowout"
      @throwoutright="onRightThrowout"
      :config="config"
      ref="vueswing"
      class="swipe-item-wrapper"
    >
      <div
        v-for="(card, index) in cards"
        :id="card.id"
        class="swipe-item flex-col"
        :style="wasSwipedWithKeyboard(card) ? {
          opacity: '0%',
          transform: 'translateX(' + (150 * wasSwipedWithKeyboard(card)) + 'px) !important',
          transitionProperty: 'transform,opacity !important',
          transitionDuration: '200ms !important',
        } : {
          opacity: '100%',
        }"
      >
        <div v-if="! card.attributes['description'] && card.attributes['image']"
          class="w-full h-full bg-contain"
          :style="{'background-image': 'url(' + card.attributes['image'].text + ')'}"
        ></div>

        <div v-else>
          <h4 v-if="card.attributes['title']" class="font-bold">{{ card.attributes['title'].text }}</h4>

          <p class="text-lg">{{ card.attributes['description'].text }}
              <button
                v-if="card.attributes['showmore']"
                class="showmore"
                @click="showModal(index)"
              >
                <i aria-hidden="true" class="material-icons">read_more</i><i aria-hidden="true" class="material-icons">menu_book</i>
              </button>
          </p>

          <div v-if="card.attributes['image']" class="w-full h-full bg-contain bg-no-repeat bg-center"
               :style="{'background-image': 'url(' + card.attributes['image'].text + ')'}"
          ></div>
        </div>
      </div>
    </vue-swing>

    <div class="swiperight"><span class="w-20 lg:w-48">Swipe Right or <br>Right Arrow Key<br> <span class="text-lg font-bold">More Me</span></span>
    </div>
      <div class="submit-button-wrapper" v-if="maybemearray.length === itemcount || maybemearray.length < 1" >
        <span class="text-xs text-white">Please try again with more variation</span>
        <button ref="restart" @click="restartActivity" type="submit" class="submitResults px-5 py-2">Restart<i aria-hidden="true" class="material-icons align-middle text-3xl">refresh</i></button>
      </div>
      <div class="submit-button-wrapper" v-else >
        <div v-if="demo !== ('1')">
          <button ref="submit" @click="submitResults" type="submit" class="submitResults px-5 py-2">Next<i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
        </div>
        <div v-else>
          <button ref="restart" @click="restartActivity" type="submit" class="submitResults px-5 py-2">Restart Demo<i aria-hidden="true" class="material-icons align-middle text-3xl icon-flipped">refresh</i></button>
        </div>
      </div>
  </div>

  <div
      v-for="(card, index) in cards"
      v-bind:id="card.id"
      v-if="card.attributes['description']"
    >
      <card-modal :ref="'modal_' + index" v-if="card.attributes['showmore']">
          <span v-html="card.attributes['showmore'].text"></span>
      </card-modal>
  </div>

</div>
</template>

<script>
import VueSwing from 'vue-swing'
import axios from 'axios'

export default {
  components: { VueSwing },
  props: {
      array: '',
      labels: '',
      route:'',
      count:'',
      demo:'',
  },
  data() {
    return {
      leftChosen: false,
      rightChosen: false,
      cards: this.array,
      itemcount: this.count,
      notmearray: [],
      maybemearray: [],
      labelsarray: this.labels,
      config: {
        allowedDirections: [
          VueSwing.Direction.LEFT,
          VueSwing.Direction.RIGHT
        ],
        minThrowOutDistance: 10,
        maxThrowOutDistance: 500
      },
      cardSwipedWithKeyboard: null,
      cardSwipedDirection: null,
    }
  },
  methods: {
    showModal(index) {
      let modal_id = "modal_" + index;
      this.$refs[modal_id][0].show(index);
    },
    ifImage() {
      return {
        'large': this.array[0] && this.array[0].attributes['image'],
      }
    },
    add () {
      this.cards.push(`${this.cards.length + 1}`)
    },
    remove () {
      this.swing()
      setTimeout(() => {
        this.cards.pop()
      }, 100)
    },
    swing () {
      const cards = this.$refs.vueswing.cards
      cards[cards.length - 1].throwOut(
        Math.random() * 100 - 50,
        Math.random() * 100 - 50
      )
    },
    wasSwipedWithKeyboard(card) {
      if (card && this.cardSwipedWithKeyboard) {
        return card.id === this.cardSwipedWithKeyboard.id ? this.cardSwipedDirection : false;
      }
    },
    swipeWithKeyboard(direction) {
      const cards = this.$refs.vueswing.cards;
      this.cardSwipedWithKeyboard = this.cards[this.cards.length - 1];
      this.cardSwipedDirection = direction;

      if (this.cards.length == 1) {
        this.focusOnSubmitButton();
      }

      if (! this.cardSwipedWithKeyboard) {
        this.focusOnSubmitButton();
        return;
      }

      setTimeout(() => {
        if (cards[cards.length - 1]) {
          cards[cards.length - 1].throwOut(direction, 0);
        }
      }, 200);
    },
    keyLeftArrow () {
      this.swipeWithKeyboard(-1);
    },
    keyRightArrow () {
      this.swipeWithKeyboard(1);
    },
    focusOnSubmitButton() {
      this.$nextTick(() => {
        if (this.$refs.restart) {
          this.$refs.restart.focus();
        } else if (this.$refs.submit) {
          this.$refs.submit.focus();
        }
      });
    },
    restartActivity() {
        $( ".submitResults").addClass( "loading" );
        location.reload();
      },
    onLeftThrowout ({ target, throwDirection }) {
        setTimeout(() => {
          this.cards.pop()
          target.className += " notme";
        }, 1)
      console.log(`Less Me ${target.textContent}!`)
    },
    onRightThrowout ({ target, throwDirection }) {
      this.maybemearray.unshift(target.id);
      this.cards.pop();
      console.log(`More Me ${target.textContent}!`)
    },
    submitResults: function (event) {
      $( ".submitResults").addClass( "loading" );
      axios.put(this.route, {
        results: this.maybemearray
      }).then(function (response) {
          console.log(response);
        }).then(function (event) {
          location.reload();
        })
    },
    handleKeyup(event) {
      if (event.keyCode == 37) {
        this.keyLeftArrow();
      }

      if (event.keyCode == 39) {
        this.keyRightArrow();
      }
    },
  },
  created() {
    window.addEventListener('keyup', this.handleKeyup);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handleKeyup);
  },
};
</script>
